import './App.css';
import './tailwind.output.css';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import TopNavbar from './components/TopNavbar/TopNavbar';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BioPage from './pages/BioPage';
import NotFoundPage from './pages/NotFoundPage';
import GigsPage from './pages/GigsPage';
import MusicPage from './pages/MusicPage';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <TopNavbar />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/bio" element={<BioPage />} />
          <Route path="/keikat" element={<GigsPage />} />
          <Route path="/musiikki" element={<MusicPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
